var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _circle2, _circle3, _circle4, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g, _path90, _path91, _rect, _path92, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeMmaNoclass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0743 57.7544L27.0234 54.9878H43.6225L42.545 57.7544H41.4384L39.5745 62.1518H38.0311L35.2645 68.7625L32.5852 62.1518H31.0127L29.1488 57.7544H28.0743Z",
    fill: "url(#paint0_radial_8775_81858)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0052 54.9901C28.5703 56.2389 28.1452 57.6828 28.0858 57.7574L27.0391 54.9901L29.0052 54.9901Z",
    fill: "url(#paint1_linear_8775_81858)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5864 62.1518H30.9609L32.1267 54.9901H33.4799L32.5864 62.1518Z",
    fill: "url(#paint2_linear_8775_81858)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0074 62.1518H39.6328L38.4671 54.9901H37.1138L38.0074 62.1518Z",
    fill: "url(#paint3_linear_8775_81858)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4605 57.7574H42.5391L41.56 54.95H40.6236L41.4605 57.7574Z",
    fill: "url(#paint4_linear_8775_81858)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2148 13.4013L28.0515 12.7469L31.1198 14.6754L31.8493 14.2181L33.8672 15.0207L16.9902 27.4851L16.5945 25.4226L17.3581 24.91L16.4644 21.3553L17.2626 20.8023L16.1557 16.0905L17.4309 15.1091L15.7173 8.12111L21.8188 11.8109L23.1279 10.9555L27.2148 13.4013Z",
    fill: "url(#paint5_radial_8775_81858)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5738 18.1429C29.1679 16.8501 28.0197 12.787 28.0232 12.6891L32.777 15.7385L29.5738 18.1429Z",
    fill: "url(#paint6_linear_8775_81858)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8601 11.8274L23.0884 10.9829L27.1394 19.0252L25.9461 19.3707L21.8601 11.8274Z",
    fill: "url(#paint7_linear_8775_81858)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1139 14.6947L31.8198 14.2286L31.9716 16.2825L31.3292 16.6892L31.1139 14.6947Z",
    fill: "url(#paint8_linear_8775_81858)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4694 15.1213L16.1251 16.1266L23.1691 22.7343L24.0468 22.1263L17.4694 15.1213Z",
    fill: "url(#paint9_linear_8775_81858)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2608 20.7891L16.4443 21.3701L20.7369 24.3872L21.4449 23.9692L17.2608 20.7891Z",
    fill: "url(#paint10_linear_8775_81858)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3727 24.8875L16.5919 25.4242L18.2936 26.4386L19.0016 26.0206L17.3727 24.8875Z",
    fill: "url(#paint11_linear_8775_81858)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1836 13.4013L42.3469 12.7469L39.2786 14.6754L38.5491 14.2181L36.5312 15.0207L53.4083 27.4851L53.804 25.4226L53.0403 24.91L53.9341 21.3553L53.1359 20.8023L54.2428 16.0905L52.9676 15.1091L54.6812 8.12111L48.5797 11.8109L47.2706 10.9555L43.1836 13.4013Z",
    fill: "url(#paint12_radial_8775_81858)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8247 18.1429C41.2306 16.8501 42.3787 12.787 42.3753 12.6891L37.6215 15.7385L40.8247 18.1429Z",
    fill: "url(#paint13_linear_8775_81858)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5383 11.8274L47.3101 10.9829L43.259 19.0252L44.4524 19.3707L48.5383 11.8274Z",
    fill: "url(#paint14_linear_8775_81858)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2845 14.6947L38.5786 14.2286L38.4268 16.2825L39.0693 16.6892L39.2845 14.6947Z",
    fill: "url(#paint15_linear_8775_81858)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.929 15.1213L54.2734 16.1266L47.2293 22.7343L46.3516 22.1263L52.929 15.1213Z",
    fill: "url(#paint16_linear_8775_81858)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1377 20.7891L53.9541 21.3701L49.6615 24.3872L48.9535 23.9692L53.1377 20.7891Z",
    fill: "url(#paint17_linear_8775_81858)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0258 24.8875L53.8065 25.4242L52.1049 26.4386L51.3968 26.0206L53.0258 24.8875Z",
    fill: "url(#paint18_linear_8775_81858)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8758 36.2461L11.4576 35.2006L14.2207 32.9154L14.0266 32.0491L17.1797 29.5547L22.3438 49.3496L15.9066 49.1197L15.6077 48.0161L10.8718 47.5793L10.3201 46.108L3.21131 45.6384L8.64956 40.966L8.29109 39.3379L11.8758 36.2461Z",
    fill: "url(#paint19_radial_8775_81858)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64608 40.9101L8.31088 39.3209L19.0199 37.9083L19.2866 38.7765L8.64608 40.9101Z",
    fill: "url(#paint20_linear_8775_81858)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8973 36.2579L11.5739 35.231L18.5794 35.3904L18.7299 36.0096L11.8973 36.2579Z",
    fill: "url(#paint21_linear_8775_81858)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3119 32.92L14.0507 32.0666L17.8728 32.5963L18.0766 33.3762L14.3119 32.92Z",
    fill: "url(#paint22_linear_8775_81858)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3742 46.1672L10.8572 47.6353L20.3634 42.6372L20.0769 41.5661L10.3742 46.1672Z",
    fill: "url(#paint23_linear_8775_81858)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1004 45.3594L15.881 49.0634L22.0394 49.3311L21.1004 45.3594Z",
    fill: "url(#paint24_linear_8775_81858)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3664 36.2461L58.7846 35.2006L56.0214 32.9154L56.2156 32.0491L53.0625 29.5547L47.8984 49.3496L54.3356 49.1197L54.6344 48.0161L59.3704 47.5793L59.9221 46.108L67.0309 45.6384L61.5926 40.966L61.9511 39.3379L58.3664 36.2461Z",
    fill: "url(#paint25_radial_8775_81858)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5961 40.9101L61.9313 39.3209L51.2223 37.9083L50.9556 38.7765L61.5961 40.9101Z",
    fill: "url(#paint26_linear_8775_81858)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3449 36.2579L58.6683 35.231L51.6628 35.3904L51.5123 36.0096L58.3449 36.2579Z",
    fill: "url(#paint27_linear_8775_81858)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9303 32.92L56.1915 32.0666L52.3693 32.5963L52.1656 33.3762L55.9303 32.92Z",
    fill: "url(#paint28_linear_8775_81858)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.868 46.1672L59.385 47.6353L49.8787 42.6372L50.1653 41.5661L59.868 46.1672Z",
    fill: "url(#paint29_linear_8775_81858)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1418 45.3594L54.3612 49.0634L48.2028 49.3311L49.1418 45.3594Z",
    fill: "url(#paint30_linear_8775_81858)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5756 4.89978L41.3402 25.7193L63.2311 25.7193L45.521 38.5864L52.2857 59.4059L34.5756 46.5387L16.8654 59.4059L23.6301 38.5864L5.91999 25.7193L27.8109 25.7193L34.5756 4.89978Z",
    fill: "url(#paint31_radial_8775_81858)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3958,
    cy: 35.9032,
    r: 21.0989,
    fill: "url(#paint32_linear_8775_81858)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3921,
    cy: 35.9032,
    r: 20.4546,
    fill: "url(#paint33_linear_8775_81858)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3972,
    cy: 35.9032,
    r: 17.9207,
    fill: "url(#paint34_linear_8775_81858)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3952,
    cy: 35.9032,
    r: 17.0499,
    fill: "#040707",
    stroke: "url(#paint35_linear_8775_81858)",
    strokeWidth: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.688 44.9524L35.0002 46.7413H36.5484C36.8357 46.7413 38.1362 46.0172 38.7505 45.6552L37.688 44.9524Z",
    fill: "#3F4040"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.309 45.0762C38.9869 45.1222 38.4003 44.7733 38.1472 44.5931V44.4426C38.3083 44.3356 38.6994 44.0478 38.9754 43.7534C39.2515 43.4589 39.7883 42.4191 40.0221 41.936C40.1487 41.9475 40.5374 41.9636 41.0804 41.936C41.6233 41.9084 41.989 41.7405 42.1041 41.66C41.989 41.9667 41.69 42.6883 41.4139 43.1208C41.0688 43.6614 39.7116 45.0186 39.309 45.0762Z",
    fill: "#3F4040"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8749 43.3325C41.6106 43.6722 40.5296 44.7244 40.0221 45.208C40.6677 45.357 42.0903 45.6209 42.6156 45.4836C43.2722 45.3121 44.4254 44.6988 45.114 43.4816C45.665 42.5079 45.7084 39.3514 45.6612 37.8948C45.5629 38.1976 45.2271 39.0555 44.6704 40.0652C44.1136 41.0749 43.1488 41.5491 42.7359 41.66C42.559 42.0759 42.1391 42.9928 41.8749 43.3325Z",
    fill: "#3F4040"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2702 46.2524C40.2773 46.3004 39.4284 45.8039 39.309 45.8039C39.0178 46.0388 38.286 46.5791 37.688 46.861C36.9406 47.2133 35.7132 47.1653 35.1206 47.2614C34.528 47.3575 34.4956 48.8629 34.6718 49.0551C34.8479 49.2473 35.6487 49.4555 38.4355 48.975C40.6648 48.5907 42.7277 46.7008 43.4804 45.8039C43.0747 45.9374 42.0646 46.2139 41.2702 46.2524Z",
    fill: "#3F4040"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0171 27.7418L33.8116 26.1245L32.2664 26.0277C31.9796 26.0097 30.6364 26.651 30.0007 26.974L31.0171 27.7418Z",
    fill: "#3F4040"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4071 27.5169C29.7314 27.4911 30.295 27.876 30.5363 28.0717L30.5269 28.2219C30.3595 28.3186 29.9512 28.5813 29.6573 28.858C29.3634 29.1346 28.7626 30.1388 28.499 30.6063C28.3734 30.5869 27.9864 30.5466 27.4428 30.5402C26.8993 30.5338 26.5237 30.6785 26.4039 30.7517C26.5379 30.4527 26.8814 29.7513 27.184 29.3369C27.5622 28.8189 29.0017 27.5492 29.4071 27.5169Z",
    fill: "#3F4040"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7372 29.0967C27.0221 28.7742 28.1668 27.7917 28.7036 27.3408C28.0686 27.1516 26.6653 26.7994 26.1324 26.9035C25.4664 27.0337 24.2771 27.5736 23.5137 28.7454C22.903 29.6828 22.6623 32.8304 22.6183 34.2871C22.7353 33.9911 23.1241 33.1558 23.7429 32.1829C24.3617 31.21 25.3543 30.797 25.7733 30.7122C25.9758 30.3081 26.4523 29.4193 26.7372 29.0967Z",
    fill: "#3F4040"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5232 26.2204C28.5172 26.2345 29.3334 26.7831 29.4526 26.7906C29.7579 26.5743 30.5221 26.0809 31.1365 25.837C31.9044 25.532 33.1265 25.6567 33.7239 25.5979C34.3213 25.539 34.4478 24.0385 34.284 23.8357C34.1202 23.6328 33.334 23.375 30.5227 23.6803C28.2736 23.9245 26.0966 25.6817 25.2893 26.5298C25.7026 26.4219 26.728 26.2091 27.5232 26.2204Z",
    fill: "#3F4040"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6762 50.2628L32.4867 50.2306L32.3438 52.4157L32.6762 50.2628Z",
    fill: "url(#paint36_linear_8775_81858)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5514 50.3659L34.3604 50.3659L34.4243 52.5406L34.5514 50.3659Z",
    fill: "url(#paint37_linear_8775_81858)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7869 49.9092L30.6017 49.863L30.137 51.9884L30.7869 49.9092Z",
    fill: "url(#paint38_linear_8775_81858)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0167 49.353L28.8396 49.2817L28.0873 51.3232L29.0167 49.353Z",
    fill: "url(#paint39_linear_8775_81858)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7243 47.5278L25.5816 47.3991L24.2894 49.167L25.7243 47.5278Z",
    fill: "url(#paint40_linear_8775_81858)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2658 48.4918L27.099 48.3987L26.095 50.3288L27.2658 48.4918Z",
    fill: "url(#paint41_linear_8775_81858)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2801 46.1766L24.1473 46.0394L22.6293 47.598L24.2801 46.1766Z",
    fill: "url(#paint42_linear_8775_81858)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0163 44.8284L22.8964 44.6798L21.2445 46.0958L23.0163 44.8284Z",
    fill: "url(#paint43_linear_8775_81858)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.92 43.1907L21.82 43.028L20.0004 44.2207L21.92 43.1907Z",
    fill: "url(#paint44_linear_8775_81858)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0817 41.5194L20.9969 41.3483L19.0767 42.3713L21.0817 41.5194Z",
    fill: "url(#paint45_linear_8775_81858)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4661 39.6903L20.4123 39.5071L18.3438 40.1817L20.4661 39.6903Z",
    fill: "url(#paint46_linear_8775_81858)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.099 37.8822L20.0677 37.6938L17.9328 38.1129L20.099 37.8822Z",
    fill: "url(#paint47_linear_8775_81858)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8895 35.9537L19.8889 35.7627L17.7144 35.8331L19.8895 35.9537Z",
    fill: "url(#paint48_linear_8775_81858)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5433 21.4434L32.3539 21.4755L32.2109 19.2904L32.5433 21.4434Z",
    fill: "url(#paint49_linear_8775_81858)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.567 21.3541L34.3761 21.3541L34.4399 19.1794L34.567 21.3541Z",
    fill: "url(#paint50_linear_8775_81858)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 21.8108L30.6173 21.857L30.1526 19.7316L30.8026 21.8108Z",
    fill: "url(#paint51_linear_8775_81858)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9542 22.4017L28.7771 22.4729L28.0248 20.4315L28.9542 22.4017Z",
    fill: "url(#paint52_linear_8775_81858)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6696 24.2891L25.5269 24.4178L24.2348 22.65L25.6696 24.2891Z",
    fill: "url(#paint53_linear_8775_81858)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2736 23.2282L27.1068 23.3213L26.1028 21.3911L27.2736 23.2282Z",
    fill: "url(#paint54_linear_8775_81858)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2879 25.5434L24.1551 25.6806L22.6371 24.122L24.2879 25.5434Z",
    fill: "url(#paint55_linear_8775_81858)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.946 26.9834L22.8261 27.1319L21.1742 25.716L22.946 26.9834Z",
    fill: "url(#paint56_linear_8775_81858)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9356 28.5292L21.8356 28.6919L20.016 27.4992L21.9356 28.5292Z",
    fill: "url(#paint57_linear_8775_81858)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0817 30.2976L20.9969 30.4687L19.0767 29.4457L21.0817 30.2976Z",
    fill: "url(#paint58_linear_8775_81858)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4739 32.0297L20.4201 32.2129L18.3517 31.5383L20.4739 32.0297Z",
    fill: "url(#paint59_linear_8775_81858)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0777 33.9483L20.0497 34.1372L17.9078 33.7556L20.0777 33.9483Z",
    fill: "url(#paint60_linear_8775_81858)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1754 21.4212L36.3648 21.4534L36.5078 19.2683L36.1754 21.4212Z",
    fill: "url(#paint61_linear_8775_81858)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0881 21.7396L38.2733 21.7858L38.738 19.6603L38.0881 21.7396Z",
    fill: "url(#paint62_linear_8775_81858)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8114 22.4253L39.9885 22.4966L40.7409 20.4551L39.8114 22.4253Z",
    fill: "url(#paint63_linear_8775_81858)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.057 24.2588L43.1996 24.3875L44.4918 22.6197L43.057 24.2588Z",
    fill: "url(#paint64_linear_8775_81858)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6327 23.1489L41.7994 23.2419L42.8035 21.3118L41.6327 23.1489Z",
    fill: "url(#paint65_linear_8775_81858)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6027 25.5131L44.7355 25.6503L46.2535 24.0917L44.6027 25.5131Z",
    fill: "url(#paint66_linear_8775_81858)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8509 26.9122L45.9708 27.0608L47.6227 25.6448L45.8509 26.9122Z",
    fill: "url(#paint67_linear_8775_81858)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9472 28.548L47.0472 28.7107L48.8668 27.518L46.9472 28.548Z",
    fill: "url(#paint68_linear_8775_81858)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7387 30.1446L47.8235 30.3157L49.7436 29.2927L47.7387 30.1446Z",
    fill: "url(#paint69_linear_8775_81858)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3542 32.0403L48.4081 32.2235L50.4765 31.5488L48.3542 32.0403Z",
    fill: "url(#paint70_linear_8775_81858)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7817 33.779L48.8097 33.9679L50.9516 33.5863L48.7817 33.779Z",
    fill: "url(#paint71_linear_8775_81858)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0567 49.7937L38.2409 49.739L38.6463 51.8909L38.0567 49.7937Z",
    fill: "url(#paint72_linear_8775_81858)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3075 50.2347L36.4977 50.2077L36.5813 52.3959L36.3075 50.2347Z",
    fill: "url(#paint73_linear_8775_81858)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9111 49.1801L40.0894 49.1118L40.807 51.1658L39.9111 49.1801Z",
    fill: "url(#paint74_linear_8775_81858)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5146 48.3205L41.6819 48.2284L42.6749 50.1642L41.5146 48.3205Z",
    fill: "url(#paint75_linear_8775_81858)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4352 46.0892L44.5613 45.9442L46.0572 47.5434L44.4352 46.0892Z",
    fill: "url(#paint76_linear_8775_81858)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.153 47.3631L43.3073 47.2506L44.5367 49.0455L43.153 47.3631Z",
    fill: "url(#paint77_linear_8775_81858)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8196 44.658L45.935 44.5058L47.6298 45.8699L45.8196 44.658Z",
    fill: "url(#paint78_linear_8775_81858)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8905 43.1187L46.9916 42.9568L48.8022 44.1632L46.8905 43.1187Z",
    fill: "url(#paint79_linear_8775_81858)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M47.771 41.3628L47.8506 41.1893L49.8007 42.1538L47.771 41.3628Z",
    fill: "url(#paint80_linear_8775_81858)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3688 39.6823L48.4323 39.5022L50.4619 40.2861L48.3688 39.6823Z",
    fill: "url(#paint81_linear_8775_81858)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7524 37.7261L48.7837 37.5377L50.9184 37.958L48.7524 37.7261Z",
    fill: "url(#paint82_linear_8775_81858)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.97 35.9488L48.975 35.7579L51.1473 35.8784L48.97 35.9488Z",
    fill: "url(#paint83_linear_8775_81858)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6342 33.4747H25.3885L23.6016 38.317H25.3885L26.3929 35.6219L26.8982 38.317H27.4516L29.8579 35.6219L28.9436 38.317H30.628L32.3846 33.4747H30.2911L28.0773 35.8625L27.6342 33.4747ZM35.1187 33.4747H32.8731L31.0861 38.317H32.8731L33.8774 35.6219L34.3827 38.317H34.9362L37.3425 35.6219L36.4281 38.317H38.1125L39.8691 33.4747H37.7756L35.5618 35.8625L35.1187 33.4747ZM43.1269 37.0375L42.3095 38.2759H38.5563L42.3095 33.4802H44.1467L45.0123 38.2759H43.4143L42.9712 34.827L41.2334 37.0375H43.1269Z",
    fill: "url(#paint84_linear_8775_81858)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8775_81858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3268 12.2804C34.1366 12.4824 33.7873 12.7812 33.3011 13.0421C32.7414 13.3425 32.1114 13.3425 31.8828 13.3425V15.6413C31.8828 17.3111 33.0649 18.0427 33.9812 18.6098C34.1021 18.6846 34.2184 18.7566 34.3268 18.8275C34.4351 18.7566 34.5514 18.6846 34.6724 18.6098C35.5887 18.0427 36.7707 17.3111 36.7707 15.6413V13.3425C36.5421 13.3425 35.9121 13.3425 35.3524 13.0421C34.8662 12.7812 34.5169 12.4824 34.3268 12.2804Z",
    fill: "url(#paint85_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3125 12.5411C34.1095 12.7655 33.5355 13.0999 33.1984 13.2433C32.7718 13.425 32.2615 13.5537 32.0175 13.5537C32.0175 13.7451 32.0172 13.9851 32.0168 14.2666C32.0163 14.666 32.0156 15.149 32.0156 15.6956C32.0156 17.1494 33.5143 18.2791 34.3125 18.6407C35.1107 18.2791 36.6094 17.1494 36.6094 15.6956C36.6094 15.149 36.6087 14.666 36.6082 14.2666C36.6078 13.9851 36.6075 13.7451 36.6075 13.5537C36.3635 13.5537 35.8532 13.425 35.4266 13.2433C35.0895 13.0999 34.5155 12.7655 34.3125 12.5411Z",
    fill: "url(#paint86_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1706 14.3476L34.135 14.3273L34.0995 14.3479L33.1134 14.9233C33.0795 14.9431 33.068 14.9866 33.0878 15.0205C33.0961 15.0347 33.1085 15.0449 33.1227 15.0506C33.1424 15.0585 33.1653 15.0576 33.1851 15.0461L34.1358 14.4914L34.7537 14.8442C34.7699 14.8534 34.7881 14.8556 34.8049 14.8517C34.8235 14.8474 34.8405 14.8357 34.8507 14.8177C34.8622 14.7975 34.8627 14.7741 34.8542 14.7543C34.8483 14.7406 34.8381 14.7287 34.8242 14.7208L34.6394 14.6152C34.6413 14.6085 34.6422 14.6013 34.6422 14.5939V14.4542C34.6422 14.4104 34.6067 14.3749 34.5629 14.3749C34.5191 14.3749 34.4836 14.4104 34.4836 14.4542V14.5263L34.1706 14.3476Z",
    fill: "url(#paint87_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0242 15.1861H33.0391V15.4318H33.3892V16.7565H33.6861V15.4318H34.0242V15.1861Z",
    fill: "url(#paint88_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1687 14.9256L34.9642 14.8142C34.9442 14.851 34.879 14.9245 34.7781 14.9245H34.1233V15.2826C34.1506 15.2817 34.2251 15.2869 34.3053 15.3156C34.4056 15.3514 34.4958 15.4689 34.4958 15.6262C34.4958 15.7836 34.4572 15.8257 34.4271 15.8715C34.397 15.9173 34.2838 15.9961 34.2179 15.9961H34.0703V16.0864C34.0904 16.0835 34.1399 16.0795 34.1777 16.0864C34.225 16.095 34.2522 16.1609 34.2838 16.2111C34.3153 16.2612 34.5288 16.5707 34.5732 16.6179C34.6176 16.6652 34.7279 16.7455 34.811 16.7698C34.8775 16.7893 34.9944 16.7779 35.0445 16.7698C35.0173 16.7579 34.9546 16.728 34.9213 16.7039C34.8798 16.6738 34.8468 16.6366 34.7508 16.5148C34.674 16.4174 34.4944 16.1389 34.4141 16.0119C34.4332 16.0033 34.4918 15.9721 34.5732 15.9159C34.6749 15.8457 34.7233 15.7032 34.7233 15.6262C34.7233 15.5493 34.7253 15.4318 34.6241 15.3265C34.5431 15.2423 34.3541 15.2078 34.2697 15.201V15.0552H35.1323C35.1708 15.0552 35.1931 15.0329 35.1931 14.9904C35.1931 14.9564 35.1768 14.933 35.1687 14.9256Z",
    fill: "url(#paint89_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6673 15.2848V15.1971C34.702 15.1971 34.7925 15.1991 34.8769 15.2067C34.9824 15.2163 35.1125 15.293 35.1632 15.3396C35.2139 15.3862 35.2523 15.5177 35.2523 15.6369C35.2523 15.7561 35.2084 15.8136 35.1221 15.8958C35.0531 15.9616 34.9655 15.9935 34.9303 16.0013C34.9504 16.0346 35.001 16.1147 35.0427 16.1684C35.0947 16.2356 35.3345 16.5931 35.4194 16.6821C35.4873 16.7534 35.5536 16.7739 35.5783 16.7753C35.5121 16.7721 35.3676 16.7643 35.3194 16.7589C35.2591 16.752 35.1564 16.6876 35.0906 16.6C35.038 16.5298 34.9006 16.3333 34.8385 16.2438C34.8015 16.1885 34.7188 16.078 34.6837 16.078H34.6016V16.0013C34.6431 16.0013 34.7501 15.9936 34.8454 15.9629C34.9646 15.9246 35.0194 15.7944 35.0194 15.6369C35.0194 15.4794 34.9714 15.3958 34.8769 15.3396C34.8013 15.2947 34.7057 15.2844 34.6673 15.2848Z",
    fill: "url(#paint90_linear_8775_81858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3258 13.3268L34.4037 13.5141L34.6059 13.5303L34.4518 13.6622L34.4989 13.8596L34.3258 13.7538L34.1527 13.8596L34.1997 13.6622L34.0457 13.5303L34.2479 13.5141L34.3258 13.3268Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3149 16.9908L34.425 17.2556L34.7109 17.2785L34.4931 17.4651L34.5596 17.7441L34.3149 17.5946L34.0701 17.7441L34.1366 17.4651L33.9188 17.2785L34.2047 17.2556L34.3149 16.9908Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4038 16.8254L33.4548 16.9481L33.5873 16.9587L33.4864 17.0451L33.5172 17.1744L33.4038 17.1051L33.2904 17.1744L33.3213 17.0451L33.2204 16.9587L33.3528 16.9481L33.4038 16.8254Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2319 16.8254L35.283 16.9481L35.4154 16.9587L35.3145 17.0451L35.3453 17.1744L35.2319 17.1051L35.1186 17.1744L35.1494 17.0451L35.0485 16.9587L35.1809 16.9481L35.2319 16.8254Z",
    fill: "#F2E5A0"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6579 23.9778C38.1804 24.1301 37.692 23.8334 37.5356 23.6548C37.3791 23.4763 37.1802 23.1005 37.0992 22.7328C37.3399 22.8405 37.816 23.1267 38.0039 23.277C38.1918 23.4273 38.5356 23.7958 38.6579 23.9778ZM38.8852 22.8257C38.6744 23.4509 38.7854 23.7913 39.0089 24.1716C38.5654 24.1368 38.2119 24.3081 37.6559 24.7015C38.3545 24.834 39.1371 24.5922 39.4943 24.4279C39.4528 24.3234 39.4263 24.1824 39.3963 24.0229C39.3257 23.6473 39.2359 23.1695 38.8852 22.8257ZM40.2599 24.6256C40.0364 24.2452 39.9254 23.9049 40.1362 23.2797C40.4869 23.6235 40.5767 24.1013 40.6473 24.4768C40.6773 24.6363 40.7038 24.7774 40.7453 24.8819C40.3881 25.0462 39.6055 25.288 38.9069 25.1555C39.4628 24.762 39.8164 24.5908 40.2599 24.6256ZM41.5015 24.0103C41.1744 24.6093 41.2273 24.9783 41.3882 25.4096C40.9405 25.2898 40.5482 25.3976 39.909 25.6943C40.6003 25.9624 41.4443 25.8639 41.8393 25.7638C41.8154 25.6491 41.8134 25.4999 41.8111 25.3311V25.3311V25.3311V25.3311C41.8059 24.9338 41.7992 24.4284 41.5015 24.0103ZM42.5462 26.0909C42.3853 25.6596 42.3325 25.2906 42.6596 24.6916C42.9573 25.1096 42.964 25.6151 42.9692 26.0124C42.9714 26.1811 42.9734 26.3304 42.9973 26.4451C42.6024 26.5452 41.7584 26.6437 41.0671 26.3755C41.7062 26.0789 42.0986 25.9711 42.5462 26.0909ZM43.8264 25.6329C43.4454 26.1992 43.464 26.5715 43.5844 27.0158C43.1497 26.8552 42.7491 26.9264 42.0853 27.1629C42.749 27.4936 43.5985 27.4734 44.0009 27.4101C43.9877 27.2937 43.9995 27.1449 44.0128 26.9767V26.9767V26.9767V26.9767V26.9767V26.9767C44.0442 26.5806 44.0842 26.0766 43.8264 25.6329ZM44.496 28.0895C44.4229 27.5962 44.4476 27.1965 44.9126 26.6571C45.1293 27.1729 45.0279 27.7029 44.9481 28.1195C44.9143 28.2965 44.8843 28.4529 44.8843 28.5792C44.4565 28.5792 43.5669 28.4585 42.9131 27.9952C43.6343 27.8545 44.0611 27.8457 44.496 28.0895ZM45.8284 27.7578C45.3143 28.2505 45.2738 29.2102 45.2738 29.2102C44.7974 28.8383 44.4421 28.8283 43.7108 28.8998C44.3443 29.3449 44.9066 29.5766 45.6176 29.6684C45.6176 29.6684 46.0659 28.5186 45.8284 27.7578ZM45.9391 30.4261C45.9391 30.4261 46.0984 29.4789 46.6697 29.0538C46.8109 29.8382 46.2234 30.9235 46.2234 30.9235C45.5292 30.7441 45.0001 30.4445 44.4267 29.9241C45.1612 29.9439 45.5125 29.998 45.9391 30.4261ZM47.4064 30.3767C46.7815 30.7183 46.492 31.6341 46.492 31.6341C46.1292 31.1508 45.7888 31.0484 45.0641 30.9267C45.5596 31.5217 46.0419 31.892 46.7044 32.1662C46.7044 32.1662 47.4372 31.1731 47.4064 30.3767ZM46.8432 32.9071C46.8432 32.9071 47.2167 32.0221 47.8707 31.7402C47.8272 32.5361 47.0052 33.4566 47.0052 33.4566C46.3711 33.1219 45.9254 32.7083 45.4874 32.0698C46.1976 32.2585 46.527 32.3921 46.8432 32.9071ZM48.2823 33.1255C47.6126 33.3678 47.1869 34.2288 47.1869 34.2288C46.902 33.6958 46.5812 33.5427 45.8836 33.3118C46.2825 33.9754 46.7027 34.415 47.3156 34.787C47.3156 34.787 48.1913 33.9173 48.2823 33.1255ZM47.3036 35.5401C47.3036 35.5401 47.846 34.7474 48.543 34.6015C48.3417 35.3727 47.3527 36.1108 47.3527 36.1108C46.798 35.6565 46.4437 35.1623 46.1419 34.4493C46.8002 34.7758 47.0963 34.9724 47.3036 35.5401ZM48.6246 36.1975C47.9136 36.2377 47.259 36.9407 47.259 36.9407C47.1388 36.3484 46.8753 36.1098 46.273 35.6888C46.4652 36.4389 46.7418 36.9804 47.2225 37.5124C47.2225 37.5124 48.3106 36.93 48.6246 36.1975ZM47.1107 38.2717C47.1107 38.2717 47.8166 37.6203 48.5287 37.6339C48.1601 38.3406 47.031 38.839 47.031 38.839C46.592 38.2721 46.3571 37.7113 46.2223 36.9488C46.791 37.4142 47.0356 37.672 47.1107 38.2717ZM48.3366 39.076C47.6275 39.0102 46.8758 39.6081 46.8758 39.6081C46.8448 39.0045 46.6197 38.7295 46.0867 38.2237C46.1653 38.994 46.3584 39.5705 46.7547 40.168C46.7547 40.168 47.9172 39.7537 48.3366 39.076ZM46.4574 40.8152C46.4574 40.8152 47.2828 40.3241 47.9766 40.4848C47.4697 41.0999 46.262 41.3538 46.262 41.3538C45.9498 40.7083 45.8361 40.111 45.862 39.3371C46.322 39.9101 46.508 40.213 46.4574 40.8152ZM47.4153 41.9277C46.7402 41.7012 45.8714 42.1109 45.8714 42.1109C45.9796 41.5163 45.8235 41.197 45.4205 40.5825C45.3205 41.3503 45.3764 41.9558 45.6253 42.6282C45.6253 42.6282 46.8518 42.4913 47.4153 41.9277ZM45.2255 43.3087C45.2255 43.3087 46.1227 42.9656 46.7788 43.2424C46.1744 43.7619 44.9411 43.806 44.9411 43.806C44.7436 43.1167 44.7335 42.5087 44.8912 41.7506C45.2466 42.3937 45.3782 42.7239 45.2255 43.3087ZM46.0244 44.5233C45.3847 44.1475 44.4185 44.3762 44.4185 44.3762C44.6496 43.7957 44.5561 43.4377 44.2721 42.7267C44.0139 43.4849 43.9472 44.1119 44.0629 44.8485C44.0629 44.8485 45.3369 44.9741 46.0244 44.5233ZM43.5249 45.4246C43.5249 45.4246 44.5063 45.274 45.114 45.6997C44.3926 46.0941 43.1327 45.8669 43.1327 45.8669C43.0763 45.1235 43.1929 44.5038 43.511 43.7687C43.7372 44.5002 43.8018 44.8645 43.5249 45.4246ZM44.091 46.6593C43.5118 46.1957 42.5228 46.2834 42.5228 46.2834C42.8348 45.742 42.7937 45.3743 42.6145 44.63C42.2502 45.3432 42.0943 45.9542 42.1032 46.6997C42.1032 46.6997 43.346 47.0068 44.091 46.6593ZM41.404 47.0757C41.404 47.0757 42.395 47.1366 42.8986 47.6815C42.11 47.9139 40.9269 47.4248 40.9269 47.4248C41.0295 46.6863 41.2749 46.1055 41.7415 45.4545C41.8076 46.2173 41.7934 46.587 41.404 47.0757ZM41.7316 48.4779C41.2755 47.8927 40.2931 47.749 40.2931 47.749C40.722 47.2946 40.7671 46.9274 40.7652 46.1618C40.2456 46.7713 39.9525 47.3295 39.7884 48.0568C39.7884 48.0568 40.9263 48.6434 41.7316 48.4779ZM38.9987 48.288C38.9987 48.288 39.9511 48.5688 40.3201 49.2124C39.4996 49.2627 38.4557 48.5216 38.4557 48.5216C38.7207 47.8246 39.0896 47.3134 39.69 46.7832C39.5839 47.5414 39.4874 47.8986 38.9987 48.288ZM38.8499 49.8102C38.604 49.1102 37.7186 48.661 37.7186 48.661C38.2699 48.3669 38.4296 48.0332 38.6718 47.3069C37.9851 47.7191 37.5293 48.1548 37.1421 48.792C37.1421 48.792 38.0339 49.7105 38.8499 49.8102ZM37.5203 50.1528C37.2744 49.4528 36.3889 49.0036 36.3889 49.0036C36.9402 48.7096 37.1 48.3759 37.3421 47.6495C36.6554 48.0618 36.1997 48.4975 35.8125 49.1346C35.8125 49.1346 36.7043 50.0532 37.5203 50.1528Z",
    fill: "url(#paint91_linear_8775_81858)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.139 23.9778C30.6165 24.1301 31.1048 23.8334 31.2613 23.6548C31.4177 23.4763 31.6167 23.1005 31.6976 22.7328C31.457 22.8405 30.9809 23.1267 30.793 23.277C30.6051 23.4273 30.2612 23.7958 30.139 23.9778ZM29.9117 22.8257C30.1224 23.4509 30.0115 23.7913 29.788 24.1716C30.2315 24.1368 30.585 24.3081 31.141 24.7015C30.4424 24.834 29.6598 24.5922 29.3025 24.4279C29.3441 24.3234 29.3706 24.1824 29.4006 24.0229C29.4712 23.6473 29.5609 23.1695 29.9117 22.8257ZM28.537 24.6256C28.7605 24.2452 28.8714 23.9049 28.6607 23.2797C28.31 23.6235 28.2202 24.1013 28.1496 24.4768C28.1196 24.6363 28.0931 24.7774 28.0515 24.8819C28.4088 25.0462 29.1914 25.288 29.89 25.1555C29.334 24.762 28.9805 24.5908 28.537 24.6256ZM27.2953 24.0103C27.6225 24.6093 27.5696 24.9783 27.4087 25.4096C27.8563 25.2898 28.2487 25.3976 28.8879 25.6943C28.1966 25.9624 27.3525 25.8639 26.9576 25.7638C26.9815 25.6491 26.9835 25.4999 26.9857 25.3311V25.3311V25.3311V25.3311C26.991 24.9338 26.9977 24.4284 27.2953 24.0103ZM26.2507 26.0909C26.4116 25.6596 26.4644 25.2906 26.1373 24.6916C25.8396 25.1096 25.8329 25.6151 25.8277 26.0124V26.0124V26.0124V26.0124V26.0124C25.8254 26.1812 25.8235 26.3304 25.7996 26.4451C26.1945 26.5452 27.0385 26.6437 27.7298 26.3755C27.0907 26.0789 26.6983 25.9711 26.2507 26.0909ZM24.9705 25.6329C25.3515 26.1992 25.3329 26.5715 25.2125 27.0158C25.6471 26.8552 26.0478 26.9264 26.7115 27.1629C26.0479 27.4936 25.1984 27.4734 24.7959 27.4101C24.8092 27.2937 24.7974 27.1449 24.784 26.9767C24.7526 26.5806 24.7127 26.0766 24.9705 25.6329ZM24.3008 28.0895C24.374 27.5962 24.3492 27.1965 23.8843 26.6571C23.6676 27.1729 23.769 27.7029 23.8488 28.1195C23.8826 28.2965 23.9126 28.4529 23.9126 28.5792C24.3404 28.5792 25.23 28.4585 25.8838 27.9952C25.1626 27.8545 24.7357 27.8457 24.3008 28.0895ZM22.9685 27.7578C23.4826 28.2505 23.5231 29.2102 23.5231 29.2102C23.9995 28.8383 24.3548 28.8283 25.0861 28.8998C24.4525 29.3449 23.8903 29.5766 23.1792 29.6684C23.1792 29.6684 22.7309 28.5186 22.9685 27.7578ZM22.8578 30.4261C22.8578 30.4261 22.6985 29.4789 22.1272 29.0538C21.9859 29.8382 22.5735 30.9235 22.5735 30.9235C23.2677 30.7441 23.7968 30.4445 24.3702 29.9241C23.6357 29.9439 23.2843 29.998 22.8578 30.4261ZM21.3905 30.3767C22.0154 30.7183 22.3049 31.6341 22.3049 31.6341C22.6677 31.1508 23.0081 31.0484 23.7327 30.9267C23.2372 31.5217 22.755 31.892 22.0925 32.1662C22.0925 32.1662 21.3597 31.1731 21.3905 30.3767ZM21.9536 32.9071C21.9536 32.9071 21.5802 32.0221 20.9262 31.7402C20.9697 32.5361 21.7917 33.4566 21.7917 33.4566C22.4258 33.1219 22.8715 32.7083 23.3095 32.0698C22.5993 32.2585 22.2699 32.3921 21.9536 32.9071ZM20.5146 33.1255C21.1842 33.3678 21.61 34.2288 21.61 34.2288C21.8949 33.6958 22.2157 33.5427 22.9133 33.3118C22.5144 33.9754 22.0942 34.415 21.4813 34.787C21.4813 34.787 20.6056 33.9173 20.5146 33.1255ZM21.4933 35.5401C21.4933 35.5401 20.9509 34.7474 20.2539 34.6015C20.4552 35.3727 21.4442 36.1108 21.4442 36.1108C21.9988 35.6565 22.3532 35.1623 22.655 34.4493C21.9967 34.7758 21.7006 34.9724 21.4933 35.5401ZM20.1722 36.1975C20.8833 36.2377 21.5378 36.9407 21.5378 36.9407C21.6581 36.3484 21.9216 36.1098 22.5238 35.6888C22.3317 36.4389 22.055 36.9804 21.5744 37.5124C21.5744 37.5124 20.4863 36.93 20.1722 36.1975ZM21.6861 38.2717C21.6861 38.2717 20.9802 37.6203 20.2682 37.6339C20.6368 38.3406 21.7658 38.839 21.7658 38.839C22.2049 38.2721 22.4398 37.7113 22.5746 36.9488C22.0059 37.4142 21.7612 37.672 21.6861 38.2717ZM20.4602 39.076C21.1693 39.0102 21.9211 39.6081 21.9211 39.6081C21.952 39.0045 22.1772 38.7295 22.7102 38.2237C22.6316 38.994 22.4384 39.5705 22.0421 40.168C22.0421 40.168 20.8796 39.7537 20.4602 39.076ZM22.3395 40.8152C22.3395 40.8152 21.514 40.3241 20.8203 40.4848C21.3272 41.0999 22.5349 41.3538 22.5349 41.3538C22.8471 40.7083 22.9608 40.111 22.9349 39.3371C22.4749 39.9101 22.2888 40.213 22.3395 40.8152ZM21.3815 41.9277C22.0567 41.7012 22.9254 42.1109 22.9254 42.1109C22.8173 41.5163 22.9734 41.197 23.3763 40.5825C23.4763 41.3503 23.4204 41.9558 23.1716 42.6282C23.1716 42.6282 21.9451 42.4913 21.3815 41.9277ZM23.5713 43.3087C23.5713 43.3087 22.6742 42.9656 22.018 43.2424C22.6225 43.7619 23.8558 43.806 23.8558 43.806C24.0532 43.1167 24.0633 42.5087 23.9057 41.7506C23.5502 42.3937 23.4187 42.7239 23.5713 43.3087ZM22.7724 44.5233C23.4122 44.1475 24.3784 44.3762 24.3784 44.3762C24.1473 43.7957 24.2407 43.4377 24.5248 42.7267C24.783 43.4849 24.8497 44.1119 24.734 44.8485C24.734 44.8485 23.4599 44.9741 22.7724 44.5233ZM25.2719 45.4246C25.2719 45.4246 24.2906 45.274 23.6829 45.6997C24.4043 46.0941 25.6642 45.8669 25.6642 45.8669C25.7206 45.1235 25.6039 44.5038 25.2859 43.7687C25.0596 44.5002 24.9951 44.8645 25.2719 45.4246ZM24.7058 46.6593C25.2851 46.1957 26.2741 46.2834 26.2741 46.2834C25.962 45.742 26.0032 45.3743 26.1823 44.63C26.5466 45.3432 26.7026 45.9542 26.6937 46.6997C26.6937 46.6997 25.4509 47.0068 24.7058 46.6593ZM27.3928 47.0757C27.3928 47.0757 26.4018 47.1366 25.8983 47.6815C26.6869 47.9139 27.8699 47.4248 27.8699 47.4248C27.7674 46.6863 27.522 46.1055 27.0553 45.4545C26.9893 46.2173 27.0035 46.587 27.3928 47.0757ZM27.0653 48.4779C27.5214 47.8927 28.5038 47.749 28.5038 47.749C28.0749 47.2946 28.0298 46.9274 28.0316 46.1618C28.5512 46.7713 28.8444 47.3295 29.0085 48.0568C29.0085 48.0568 27.8706 48.6434 27.0653 48.4779ZM29.7981 48.288C29.7981 48.288 28.8458 48.5688 28.4767 49.2124C29.2973 49.2627 30.3412 48.5216 30.3412 48.5216C30.0762 47.8246 29.7072 47.3134 29.1069 46.7832C29.213 47.5414 29.3094 47.8986 29.7981 48.288ZM29.9469 49.8102C30.1929 49.1102 31.0783 48.661 31.0783 48.661C30.527 48.3669 30.3672 48.0332 30.1251 47.3069C30.8118 47.7191 31.2675 48.1548 31.6547 48.792C31.6547 48.792 30.763 49.7105 29.9469 49.8102ZM31.2766 50.1528C31.5225 49.4528 32.4079 49.0036 32.4079 49.0036C31.8566 48.7096 31.6969 48.3759 31.4547 47.6495C32.1414 48.0618 32.5972 48.4975 32.9844 49.1346C32.9844 49.1346 32.0926 50.0532 31.2766 50.1528Z",
    fill: "url(#paint92_linear_8775_81858)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.3516,
    y: 48.7112,
    width: 2.08737,
    height: 0.774416,
    rx: 0.387208,
    fill: "url(#paint93_linear_8775_81858)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0902 43.5115L52.8993 44.8283L53.23 44.0951L52.5881 43.5796C52.9966 43.3397 53.8194 42.8424 53.8428 42.7723C53.8661 42.7023 54.034 42.1466 54.1151 41.8775L53.0257 42.5194C53.081 42.1952 53.0902 41.5098 52.6855 41.362C52.1795 41.1772 51.7783 41.4809 51.4936 42.2374C51.2215 42.9605 51.1555 43.2095 51.0902 43.5115ZM50.978 43.6787C50.6437 44.3183 49.9474 45.6144 49.8369 45.682L51.4936 47.3895L52.6855 45.4791L52.3727 44.8283L51.4936 46.299L51.2908 46.0877L51.7134 45.3354L51.4936 44.6085L50.978 45.3946L51.1555 45.9861L50.6484 45.4791L51.2908 44.3126L50.978 43.6787ZM48.5365 47.5477L48.7014 48.1495L49.2086 47.6337L49.8604 48.4479L49.5882 48.8801L49.7602 49.5413L51.1212 47.8132L50.935 47.1824L50.455 47.7196L49.7172 46.9818L49.9751 46.5377L49.7172 45.9861L48.5365 47.5477ZM48.3552 47.8132C47.9073 48.2802 46.9744 49.2309 46.8255 49.2968L47.9842 51.2916L48.5365 50.7806L48.0749 50.0882L48.7014 49.5413L48.6519 48.7858L47.9842 49.3381L47.9018 49.7749L47.6298 49.3381L48.5365 48.4479L48.3552 47.8132ZM45.2022 50.6816C45.3099 50.6499 46.2343 49.9082 46.683 49.5413L46.7464 50.151L46.39 50.4282C46.5193 50.7713 46.7875 51.4545 46.8255 51.4418C46.8636 51.4291 47.269 51.0986 47.467 50.935V51.6477C46.91 52.0726 45.7945 52.9147 45.7882 52.883C45.7817 52.8507 45.7858 52.4705 45.7875 52.3101L45.7882 52.2416C45.7882 52.2099 46.0574 52.0014 46.192 51.9011L45.7882 50.935L45.2022 51.3388V50.6816ZM43.8399 51.5922C43.839 51.6239 44.115 52.6402 44.2549 53.1443L45.3829 52.5187V53.1839L43.7121 54.0075C43.568 53.3159 43.2861 51.9264 43.3114 51.9011C43.3368 51.8757 43.6743 51.6846 43.8399 51.5922ZM51.8166 43.0751C51.8339 43.0281 52.0762 42.4623 52.1952 42.1853L52.457 42.3072L52.1952 42.9983L52.3712 43.4455L51.8166 43.0751ZM22.718 49.737L22.1865 49.2666L20.8029 49.8511L21.7718 50.7562H22.3135C22.2679 50.7562 21.5723 51.1458 21.2302 51.3406C21.4179 51.5211 21.7975 51.8722 21.8146 51.8323C21.8317 51.7924 23.1996 51.0983 23.8814 50.7562L23.3968 50.2858L22.4917 50.7063L21.8787 50.1361L22.718 49.737ZM34.4509 54.0561L32.2792 53.9583L31.9752 54.5881C31.9498 54.7003 31.9317 54.953 32.062 55.0659C32.1923 55.1788 32.4928 55.2288 32.6267 55.2396H33.1136C33.201 55.2396 33.2265 55.5484 33.1136 55.5484C33.0233 55.5484 32.1636 55.4975 31.745 55.472L31.3118 55.8687C31.9078 55.9225 33.1428 56.0302 33.3146 56.0302C33.5293 56.0302 33.9857 55.6812 33.8515 55.1913C33.7441 54.7994 33.1938 54.764 32.9321 54.7954C32.8012 54.7954 32.5483 54.7618 32.5831 54.6276C32.618 54.4934 32.7095 54.4598 32.7509 54.4598L34.0326 54.5068L34.4509 54.0561ZM23.614 51.4889C23.5785 51.4889 22.8859 51.5244 22.8267 51.5481L23.4305 52.0276L24.3126 51.9625C24.0916 51.8046 23.6424 51.4889 23.614 51.4889ZM19.6785 47.0922C19.8879 46.7317 19.7383 46.2378 19.1889 45.642C18.6395 45.0462 17.6613 44.9012 17.1794 45.1597C16.6783 45.4285 16.8457 46.2938 17.0572 46.5326C17.1068 46.5887 17.1493 46.6479 17.1934 46.7093L17.1934 46.7093L17.1934 46.7093L17.1934 46.7093L17.1934 46.7093C17.3482 46.925 17.5222 47.1674 18.0919 47.3937C18.8239 47.6843 19.5784 47.2644 19.6785 47.0922ZM18.7196 46.8253C18.9688 46.7289 19.1832 46.4922 18.8007 46.0597C18.5104 45.7034 18.1174 45.6637 17.8618 45.7496C17.5435 45.8566 17.6024 46.3519 17.8591 46.6128C18.1595 46.918 18.5664 46.8846 18.7196 46.8253ZM28.1981 52.8669C28.9691 53.1166 29.3417 53.4736 29.336 53.8905C29.3333 54.0897 28.8817 54.8257 28.1013 54.9314C27.4938 55.0137 27.2232 54.8878 26.9826 54.7757L26.9826 54.7757L26.9825 54.7757C26.914 54.7438 26.8479 54.7131 26.7772 54.6885C26.4758 54.5841 25.9055 53.9122 26.2103 53.4321C26.3101 53.2751 26.4829 53.1305 26.6978 53.018C26.3683 53.1677 25.9345 53.3224 25.6995 53.2436C25.5936 53.208 25.3517 53.0852 25.1048 52.9599L25.1048 52.9598L25.1048 52.9598C24.7938 52.802 24.4751 52.6401 24.4109 52.6439C24.3186 52.6494 24.2042 52.7146 24.1586 52.7466C24.6994 53.064 25.7787 53.706 25.7693 53.7348C25.7599 53.7636 25.2611 53.9019 25.0129 53.9675C24.3993 53.612 23.2406 52.873 23.1815 52.7887C23.0302 52.5724 23.1151 52.3116 23.984 52.1759C24.5506 52.0874 25.0694 52.4022 25.4122 52.6102C25.5681 52.7049 25.6876 52.7774 25.7586 52.7797C25.9855 52.7872 26.0727 52.7693 26.0962 52.6974C26.1151 52.6399 26.0766 52.5437 26.0195 52.4974L24.7613 51.6833C24.9913 51.6229 25.4651 51.5114 25.5203 51.549C25.5406 51.5628 25.6719 51.6293 25.8498 51.7193L25.8499 51.7193L25.8499 51.7193L25.85 51.7194C26.2772 51.9354 26.9725 52.2872 27.0432 52.3722C27.1433 52.4926 27.2918 52.7122 27.0002 52.8686C26.9548 52.893 26.8999 52.9214 26.8382 52.9516C27.238 52.7818 27.7444 52.7199 28.1981 52.8669ZM28.0647 53.4213C28.6102 53.6106 28.5394 53.922 28.3696 54.1282C28.2651 54.2551 27.9269 54.4837 27.5154 54.3651C27.1637 54.2636 26.8695 53.8609 27.0944 53.6115C27.275 53.4113 27.637 53.2532 28.0647 53.4213ZM17.0765 42.4536C17.2996 42.536 17.7517 42.7163 17.7754 42.7788C17.7836 42.8003 17.8472 42.9274 17.9352 43.1032C18.1655 43.563 18.5628 44.3565 18.5722 44.4694C18.5852 44.6255 18.4327 44.8726 18.104 44.8335C17.7754 44.7945 17.1571 44.6264 16.9564 44.3548C16.8879 44.262 16.7525 43.9918 16.6163 43.72L16.6163 43.72C16.4547 43.3974 16.2921 43.0727 16.2387 43.0398C16.1599 42.9914 16.0288 42.9793 15.9731 42.9793C16.2343 43.5494 16.7505 44.6942 16.7262 44.7124C16.702 44.7306 16.2141 44.558 15.9731 44.4694C15.6742 43.8264 15.1484 42.5566 15.1484 42.4536C15.1484 42.1896 15.3676 42.0247 16.1573 42.4116C16.6722 42.6639 16.9168 43.2193 17.0784 43.5862C17.1519 43.7532 17.2082 43.8811 17.265 43.9237C17.4467 44.06 17.5801 44.1448 17.6407 44.0994C17.6891 44.063 17.6609 43.9127 17.6407 43.842L17.0765 42.4536ZM20.6581 47.6028C20.6201 47.5479 20.1378 47.4823 19.9013 47.4563L20.7846 48.6671C20.8212 48.7307 20.8228 48.8343 20.7845 48.8812C20.7368 48.94 20.649 48.9254 20.4398 48.8372C20.3744 48.8096 20.2888 48.6991 20.1771 48.5548C19.9316 48.2379 19.5599 47.7581 18.9993 47.6378C18.1394 47.4533 17.9667 47.6664 18.0305 47.9226C18.0554 48.0224 18.8726 49.1274 19.3182 49.6791C19.5734 49.7067 20.0886 49.7562 20.1077 49.7327C20.1268 49.7093 19.3491 48.7232 18.9578 48.2331C19.0119 48.2197 19.142 48.1997 19.2301 48.2277C19.2915 48.2472 19.5311 48.5124 19.7649 48.7712L19.7649 48.7712C19.9505 48.9766 20.1324 49.178 20.2185 49.2491C20.4789 49.464 21.2388 49.4065 21.5672 49.3649C21.8955 49.3232 21.8355 49.065 21.7851 48.9168C21.7496 48.8121 21.2264 48.2347 20.905 47.8799L20.9049 47.8799L20.9049 47.8799C20.771 47.7321 20.6721 47.6229 20.6581 47.6028ZM30.274 53.4898C30.2384 53.4785 30.1097 53.5862 29.9677 53.705L29.9677 53.705C29.8556 53.7987 29.7352 53.8994 29.6457 53.9542L31.0188 54.1576C31.0868 54.1855 31.1513 54.2665 31.1498 54.327C31.148 54.4027 31.0543 54.4296 30.8348 54.4877C30.7487 54.5105 30.5558 54.4805 30.3356 54.4461C29.994 54.3929 29.5867 54.3294 29.4102 54.4369C28.659 54.8942 28.6016 55.195 28.8088 55.3587C28.8615 55.4003 29.3455 55.5061 29.8671 55.6202L29.8671 55.6202L29.8672 55.6202L29.8672 55.6202C30.1449 55.6809 30.4332 55.7439 30.6729 55.8009C30.8917 55.6667 31.2068 55.3424 31.2075 55.3121C31.2078 55.2997 31.0272 55.2744 30.7719 55.2387L30.7719 55.2387L30.7719 55.2387C30.4036 55.1872 29.8801 55.114 29.5203 55.0263C29.5549 54.9826 29.6844 54.8601 29.7712 54.8283C29.8334 54.8056 30.1205 54.8508 30.402 54.8951C30.6122 54.9282 30.8192 54.9608 30.927 54.9642C31.2645 54.975 31.5695 54.7015 31.8038 54.4677C32.0381 54.234 31.9344 53.8932 31.8038 53.8066C31.7119 53.7457 31.0298 53.6259 30.6069 53.5515L30.6068 53.5515L30.6068 53.5515L30.6068 53.5515L30.6067 53.5515C30.4293 53.5203 30.2975 53.4972 30.274 53.4898ZM42.0907 52.5666L41.9527 52.4205L41.4285 52.6624L40.8546 55.1607L42.4659 54.5604L42.4498 54.0123L41.6318 54.2745L41.8865 53.1658C42.0639 53.3553 42.2698 53.5772 42.4498 53.7754C42.5774 53.916 42.6904 54.0428 42.7707 54.1372C42.8113 54.1848 42.8408 54.221 42.8591 54.2452C42.8606 54.2471 43.5082 54.107 43.5082 54.107C43.5082 54.107 43.0249 53.577 42.8637 53.3995C42.6055 53.1153 42.2963 52.7845 42.0907 52.5666ZM37.025 53.8339C37.3516 53.8695 37.7423 54.0236 37.9264 54.4385C37.9816 54.5629 37.9668 54.7008 37.9486 54.7932C37.9277 54.8989 37.8881 55.0124 37.8373 55.1224C37.7764 55.2543 37.6927 55.3953 37.5898 55.5232L37.8688 55.9471L37.0667 56.0734L37.0267 55.9197C37.016 55.9254 37.0073 55.9301 36.9999 55.9342C36.982 55.9439 36.9717 55.9495 36.961 55.9539C36.9463 55.96 36.9306 55.9638 36.8937 55.973L36.8884 55.9743C36.7402 56.011 36.6294 56.0151 36.4655 56.0151C36.2577 56.0151 36.0208 55.9629 35.826 55.8489C35.6293 55.7338 35.4395 55.5299 35.436 55.2295C35.4329 54.956 35.5667 54.6861 35.7039 54.485C35.8442 54.2793 36.024 54.0936 36.179 53.9903C36.2819 53.9217 36.4201 53.877 36.5552 53.8519C36.6961 53.8257 36.8593 53.8159 37.025 53.8339ZM37.1763 55.1443L37.0667 54.9927L36.3239 55.0298L36.6784 55.4506C36.6235 55.4546 36.5556 55.456 36.4655 55.456C36.3406 55.456 36.2044 55.4225 36.1084 55.3663C36.0143 55.3113 35.9956 55.2606 35.9951 55.2231C35.994 55.1207 36.0516 54.9674 36.1657 54.8001C36.2768 54.6374 36.4084 54.5093 36.4891 54.4555C36.5041 54.4455 36.5599 54.4197 36.6575 54.4016C36.7493 54.3845 36.8575 54.3781 36.9645 54.3898C37.1741 54.4126 37.3295 54.4952 37.4057 54.645C37.4052 54.6528 37.4038 54.6658 37.4 54.685C37.3898 54.7371 37.3668 54.8077 37.3298 54.8879C37.2887 54.9768 37.2358 55.0658 37.1763 55.1443ZM40.2589 55.2006C40.3661 55.1408 40.4219 55.043 40.4516 54.9745C40.4834 54.901 40.503 54.8194 40.5162 54.7419C40.5428 54.586 40.5514 54.3972 40.5531 54.2114C40.5549 54.0246 40.5496 53.8273 40.5449 53.6499L40.5448 53.6461C40.54 53.4638 40.5359 53.3074 40.539 53.1918L39.9269 53.2734C39.9231 53.4166 39.9243 53.5591 39.9254 53.7011C39.928 54.0235 39.9306 54.3439 39.8755 54.6675C39.8233 54.9738 39.3149 55.0789 39.0783 55.0497C38.8594 54.9944 38.8914 54.2056 38.9012 53.9623C38.9016 53.9547 38.9018 53.9476 38.9021 53.9411C38.9067 53.8243 38.9112 53.7105 38.9119 53.6033L38.3056 53.6774C38.3049 53.78 38.3 53.8974 38.2947 54.0226C38.2764 54.4603 38.2541 54.9941 38.393 55.33C38.4599 55.4917 38.656 55.563 39.0783 55.563C39.6709 55.563 39.9626 55.3823 40.1626 55.2583C40.1971 55.237 40.2288 55.2173 40.2589 55.2006Z",
    fill: "#040707"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8775_81858",
    x: 31.8828,
    y: 12.2804,
    width: 5.39062,
    height: 7.04715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8775_81858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8775_81858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.323 54.9878) rotate(90) scale(13.7747 25.1087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#947140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8775_81858",
    x1: 28.2046,
    y1: 53.9176,
    x2: 28.2046,
    y2: 57.7573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B59870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8775_81858",
    x1: 32.2204,
    y1: 54.9901,
    x2: 31.8086,
    y2: 62.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B79A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8775_81858",
    x1: 38.3733,
    y1: 54.9901,
    x2: 38.7852,
    y2: 62.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C7A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8775_81858",
    x1: 41.5814,
    y1: 54.95,
    x2: 41.6557,
    y2: 57.7574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7E4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0718 19.3339) rotate(-126.79) scale(14.1008 25.9318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#947140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8775_81858",
    x1: 29.9456,
    y1: 20.6368,
    x2: 30.3176,
    y2: 13.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B59870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8775_81858",
    x1: 26.6419,
    y1: 17.414,
    x2: 22.5858,
    y2: 11.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B79A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8775_81858",
    x1: 31.7769,
    y1: 14.4094,
    x2: 31.8093,
    y2: 16.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8775_81858",
    x1: 23.6069,
    y1: 22.2404,
    x2: 16.4441,
    y2: 15.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#987545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8775_81858",
    x1: 18.9183,
    y1: 23.2385,
    x2: 17.1367,
    y2: 20.9822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7E4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8775_81858",
    x1: 16.5919,
    y1: 25.7224,
    x2: 18.244,
    y2: 25.2649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7E4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3266 19.3339) rotate(-53.2105) scale(14.1008 25.9318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#947140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8775_81858",
    x1: 40.4529,
    y1: 20.6368,
    x2: 40.0809,
    y2: 13.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B59870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8775_81858",
    x1: 43.7566,
    y1: 17.414,
    x2: 47.8126,
    y2: 11.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B79A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8775_81858",
    x1: 38.6215,
    y1: 14.4094,
    x2: 38.5891,
    y2: 16.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8775_81858",
    x1: 46.7916,
    y1: 22.2404,
    x2: 53.9543,
    y2: 15.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#987545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8775_81858",
    x1: 51.4802,
    y1: 23.2385,
    x2: 53.2617,
    y2: 20.9822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7E4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8775_81858",
    x1: 53.8065,
    y1: 25.7224,
    x2: 52.1545,
    y2: 25.2649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7E4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2387 41.1663) rotate(165) scale(17.5869 35.4228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#947140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8775_81858",
    x1: 19.0759,
    y1: 36.9408,
    x2: 8.58562,
    y2: 39.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A7848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8775_81858",
    x1: 17.3704,
    y1: 35.6184,
    x2: 11.5715,
    y2: 35.4149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFA47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A38255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8775_81858",
    x1: 16.0661,
    y1: 31.1465,
    x2: 16.0939,
    y2: 33.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5B187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A28454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8775_81858",
    x1: 19.3372,
    y1: 44.2993,
    x2: 10.623,
    y2: 47.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8775_81858",
    x1: 22.5357,
    y1: 49.6873,
    x2: 16.7362,
    y2: 50.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B89B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B18D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0034 41.1663) rotate(15) scale(17.5869 35.4228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#947140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8775_81858",
    x1: 51.1663,
    y1: 36.9408,
    x2: 61.6566,
    y2: 39.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A7848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8775_81858",
    x1: 52.8718,
    y1: 35.6184,
    x2: 58.6707,
    y2: 35.4149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFA47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A38255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8775_81858",
    x1: 54.1761,
    y1: 31.1465,
    x2: 54.1483,
    y2: 33.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5B187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A28454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8775_81858",
    x1: 50.905,
    y1: 44.2993,
    x2: 59.6192,
    y2: 47.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8775_81858",
    x1: 47.7065,
    y1: 49.6873,
    x2: 53.506,
    y2: 50.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B89B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B18D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_8775_81858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5756 35.03) rotate(90) scale(30.1302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#942020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D1416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8775_81858",
    x1: 34.3958,
    y1: 14.8043,
    x2: 34.3958,
    y2: 57.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9F3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#1E100D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8775_81858",
    x1: 53.3031,
    y1: 30.2605,
    x2: 17.11,
    y2: 37.3136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349801,
    stopColor: "#9A7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515717,
    stopColor: "#ECDEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70749,
    stopColor: "#B29B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABF90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8775_81858",
    x1: 40.1223,
    y1: 53.8238,
    x2: 23.7913,
    y2: 22.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#855B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515717,
    stopColor: "#7D5535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70749,
    stopColor: "#845A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8775_81858",
    x1: 34.3952,
    y1: 18.9532,
    x2: 34.3952,
    y2: 52.8531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E3D09A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8775_81858",
    x1: 32.51,
    y1: 50.2306,
    x2: 32.51,
    y2: 52.4157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8775_81858",
    x1: 34.3842,
    y1: 50.3496,
    x2: 34.5911,
    y2: 52.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8775_81858",
    x1: 30.6287,
    y1: 49.8529,
    x2: 30.3026,
    y2: 52.0136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8775_81858",
    x1: 28.8677,
    y1: 49.2755,
    x2: 28.2479,
    y2: 51.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8775_81858",
    x1: 25.6012,
    y1: 47.4116,
    x2: 24.4297,
    y2: 49.2561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8775_81858",
    x1: 27.1277,
    y1: 48.3961,
    x2: 26.2483,
    y2: 50.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8775_81858",
    x1: 24.1755,
    y1: 46.0451,
    x2: 22.7566,
    y2: 47.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8775_81858",
    x1: 22.924,
    y1: 44.6881,
    x2: 21.3616,
    y2: 46.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8775_81858",
    x1: 21.8463,
    y1: 43.0398,
    x2: 20.1011,
    y2: 44.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8775_81858",
    x1: 21.022,
    y1: 41.3624,
    x2: 19.1648,
    y2: 42.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8775_81858",
    x1: 20.4346,
    y1: 39.5253,
    x2: 18.406,
    y2: 40.3373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8775_81858",
    x1: 20.0877,
    y1: 37.7146,
    x2: 17.9756,
    y2: 38.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8775_81858",
    x1: 19.9053,
    y1: 35.7865,
    x2: 17.7306,
    y2: 35.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8775_81858",
    x1: 32.3771,
    y1: 21.4755,
    x2: 32.3771,
    y2: 19.2904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8775_81858",
    x1: 34.3998,
    y1: 21.3704,
    x2: 34.6067,
    y2: 19.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8775_81858",
    x1: 30.6443,
    y1: 21.8671,
    x2: 30.3182,
    y2: 19.7064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_8775_81858",
    x1: 28.8052,
    y1: 22.4792,
    x2: 28.1854,
    y2: 20.3838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_8775_81858",
    x1: 25.5465,
    y1: 24.4054,
    x2: 24.3751,
    y2: 22.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_8775_81858",
    x1: 27.1355,
    y1: 23.3239,
    x2: 26.2561,
    y2: 21.3236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_8775_81858",
    x1: 24.1833,
    y1: 25.6749,
    x2: 22.7644,
    y2: 24.0132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_8775_81858",
    x1: 22.8537,
    y1: 27.1237,
    x2: 21.2912,
    y2: 25.5961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_8775_81858",
    x1: 21.862,
    y1: 28.6802,
    x2: 20.1167,
    y2: 27.3653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_8775_81858",
    x1: 21.022,
    y1: 30.4546,
    x2: 19.1648,
    y2: 29.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_8775_81858",
    x1: 20.4424,
    y1: 32.1947,
    x2: 18.4138,
    y2: 31.3827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_8775_81858",
    x1: 20.0693,
    y1: 34.1161,
    x2: 17.9477,
    y2: 33.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_8775_81858",
    x1: 36.3416,
    y1: 21.4534,
    x2: 36.3416,
    y2: 19.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_8775_81858",
    x1: 38.2463,
    y1: 21.7958,
    x2: 38.5724,
    y2: 19.6352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_8775_81858",
    x1: 39.9604,
    y1: 22.5028,
    x2: 40.5803,
    y2: 20.4075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_8775_81858",
    x1: 43.18,
    y1: 24.3751,
    x2: 44.3515,
    y2: 22.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_8775_81858",
    x1: 41.7707,
    y1: 23.2445,
    x2: 42.6501,
    y2: 21.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_8775_81858",
    x1: 44.7073,
    y1: 25.6446,
    x2: 46.1262,
    y2: 23.9828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_8775_81858",
    x1: 45.9432,
    y1: 27.0525,
    x2: 47.5056,
    y2: 25.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_8775_81858",
    x1: 47.0209,
    y1: 28.6989,
    x2: 48.7661,
    y2: 27.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_8775_81858",
    x1: 47.7983,
    y1: 30.3016,
    x2: 49.6555,
    y2: 29.1503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_8775_81858",
    x1: 48.3857,
    y1: 32.2052,
    x2: 50.4143,
    y2: 31.3932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_8775_81858",
    x1: 48.7901,
    y1: 33.9468,
    x2: 50.9116,
    y2: 33.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_8775_81858",
    x1: 38.2178,
    y1: 49.7418,
    x2: 38.4813,
    y2: 51.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_8775_81858",
    x1: 36.4745,
    y1: 50.2071,
    x2: 36.4152,
    y2: 52.3914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_8775_81858",
    x1: 40.0614,
    y1: 49.1051,
    x2: 40.6456,
    y2: 51.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_8775_81858",
    x1: 41.6532,
    y1: 48.2256,
    x2: 42.5212,
    y2: 50.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_8775_81858",
    x1: 44.5433,
    y1: 45.959,
    x2: 45.9287,
    y2: 47.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_8775_81858",
    x1: 43.2785,
    y1: 47.2514,
    x2: 44.3927,
    y2: 49.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_8775_81858",
    x1: 45.9076,
    y1: 44.5149,
    x2: 47.5166,
    y2: 45.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_8775_81858",
    x1: 46.9652,
    y1: 42.9683,
    x2: 48.7004,
    y2: 44.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_8775_81858",
    x1: 47.8259,
    y1: 41.2041,
    x2: 49.7169,
    y2: 42.2989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_8775_81858",
    x1: 48.4091,
    y1: 39.5192,
    x2: 50.3915,
    y2: 40.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_8775_81858",
    x1: 48.7638,
    y1: 37.5585,
    x2: 50.8755,
    y2: 38.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_8775_81858",
    x1: 48.9581,
    y1: 35.7812,
    x2: 51.1273,
    y2: 36.0447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_8775_81858",
    x1: 34.3069,
    y1: 33.4747,
    x2: 34.3069,
    y2: 38.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_8775_81858",
    x1: 34.3268,
    y1: 12.2804,
    x2: 34.3268,
    y2: 18.8275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#F5CF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C07A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_8775_81858",
    x1: 34.3125,
    y1: 12.5411,
    x2: 34.3125,
    y2: 18.6407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_8775_81858",
    x1: 33.9691,
    y1: 14.1268,
    x2: 33.9691,
    y2: 15.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_8775_81858",
    x1: 33.5316,
    y1: 14.7539,
    x2: 33.5316,
    y2: 16.7565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_8775_81858",
    x1: 34.6317,
    y1: 14.273,
    x2: 34.6317,
    y2: 16.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_8775_81858",
    x1: 35.0899,
    y1: 14.7628,
    x2: 35.0899,
    y2: 16.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_8775_81858",
    x1: 47.3828,
    y1: 22.1648,
    x2: 31.1109,
    y2: 40.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#EBE8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_8775_81858",
    x1: 21.4141,
    y1: 22.1648,
    x2: 37.686,
    y2: 40.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#EBE8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_8775_81858",
    x1: 35.2366,
    y1: 48.6952,
    x2: 35.0945,
    y2: 49.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#EBE8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B162"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeMmaNoclass);
export default __webpack_public_path__ + "static/media/badge-mma-noclass.a127a2036baade85b64363dabd790632.svg";
export { ForwardRef as ReactComponent };